<template>
     <div v-show="show">
        <main class="layoutContent">
                <!-- Encabezado contenido principal -->
                <header class="page-header">
                    <div class="container pt-2">
                        <div class="row align-items-center justify-content-between">
                            <div class="col-auto pt-1">
                                <h1 class="page-header--title">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                        class="bi bi-file-earmark-text" viewBox="0 0 16 16">
                                        <path
                                            d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z" />
                                        <path
                                            d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                    </svg>
                                    ENCUESTA RESERVA  
                                </h1>
                                <p class="page-header--subtitle">
                                    Plan de Vacaciones {{ xplan }}
                                </p>
                            </div>
                            <div class="col-12 col-xl-auto mt-4">
                                <!--<div class="text-right">
                                    <div class="text-white">Reserva <span class="ml-2 p-2 page-header--title">{{  }}</span></div>
                                    <p class="page-header--subtitle">Fecha<span class="ml-2 p-2 font-weight-bold ">{{  }}</span></p>
                                </div>-->
                                
                            </div>
                        </div>
                    </div>
                </header>
                <!-- Fin encabezado contenido principal -->

                <!-- Cuerpo contenido principal -->
                <div class="container content-body">
                    <div class="row">
                        <!-- Bloque Personas-->
                        <div class="col-xl-4 mb-2">
                            <!-- Card Datos solicitante -->
                            <div class="card mb-2">
                                <div class="card-header">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" fill="currentColor"
                                        class="bi bi-box" viewBox="0 0 16 16">
                                        <path
                                            d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5 8.186 1.113zM15 4.239l-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z" />
                                    </svg>
                                    Datos de la RESERVA
                                </div>                            
                                <div class="card-body">                                 
                                    <div class="form-row">                          
                                        <div class="form-group col-6">             
                                            <label>Referencia</label>                               
                                            <input class="form-control" type="text" disabled v-model="R.id"/>
                                        </div>
                                        <div class="form-group col-6">             
                                            <label>Periodo</label>                               
                                            <input class="form-control" type="text" disabled v-model="R.per"/>
                                        </div>
                                    </div>
                                    <div class="form-row">                          
                                        <div class="form-group col-12">             
                                            <label>Establecimiento</label>                               
                                            <input class="form-control" type="text" disabled v-model="R.hotel"/>
                                            <input class="form-control" type="text" disabled v-model="R.pob"/>
                                            <input class="form-control" type="text" disabled v-model="R.pro"/>                                            
                                        </div>
                                    </div>
                                    <div class="form-row">                          
                                        <div class="form-group col-12">             
                                            <label>Introduce Comentarios / Sugerencias</label>                                          
                                            <textarea class="form-control" cols="30" rows="3" v-model="obs"/>                                                                    
                                        </div>                            
                                    </div>                                    
                                    <div class="form-row">                          
                                        <div class="form-group col-12 text-center"> 
                                            <b-btn variant="secondary" size="sm" class="mt-1 mx-2" @click="enviar">
                                                <b-icon icon="save" variant="light" aria-hidden="true"></b-icon> ENVIAR ENCUESTA
                                            </b-btn>
                                        </div>
                                    </div>                                    
                                </div>                            
                            </div>
                            <!-- Fin Card Datos solicitante -->
                        </div>

                        <!-- Bloque Establecimientos y Observaciones -->
                        <div class="col-xl-8 mb-1">
                            <!-- Card Datos solicitante -->
                            <div class="card mb-0">
                                <div class="card-header d-flex flex-column flex-sm-row align-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" fill="currentColor"
                                        class="bi bi-box mr-1" viewBox="0 0 16 16">
                                        <path
                                            d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5 8.186 1.113zM15 4.239l-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z" />
                                    </svg> Indique el grado de satisfacción con el servicio prestado                                    
                                </div>
                                <div class="card-body">
                                    <div class="box mb-0">
                                        <div class="box-content form-row p-1 ">                                          
                                            <div class="form-group col-11" v-for="(item) in faq" :key="item.id">
                                                <b-form-group :label="item.id + ') ' + item.name" label-class="font-weight-bold">
                                                    <b-form-radio-group                                                            
                                                        v-model="resp[item.id]"
                                                        :options="options[item.res]"/>                                                        
                                                </b-form-group>
                                            </div>                                                                                                                                   
                                        </div>                                         
                                    </div>

                                </div>
                            </div>                                                      
                        </div>
                    </div>
                </div>
                <!-- Fin Cuerpo contenido principal -->
            </main>
    </div>    
</template>

<script>

//import { mixinFinder } from "@/mixins/mixinFinder.js";
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    name: 'encuesta',

  
    data() {
        return {    
            modulo: 'ENCUESTA',

            show: false,

            xplan: 'VERANO',
            EMP: {},
            R: {},

            reserva: 0,                     
            resp: [0,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4],
            obs: '',

            //se recojen desde la tabla encuestas_faq y por año de la reserva
            faq:[
                [   { id: 1,  res: 1, name: "Considera sencilla la página web para cursar la solicitud, reserva u obtención de bono de asistencia" },
                    { id: 2,  res: 1, name: "Valore la atención recibida por la oficina de Fondos Sociales" },
                    { id: 3,  res: 1, name: "Cómo valora la atención recibida en la entrega de llaves de su instalación correspondiente" },
                    { id: 4,  res: 1, name: "Apartamento / Hotel" },
                    { id: 5,  res: 1, name: "Ubicación del Apartamento / Hotel" },
                    { id: 6,  res: 1, name: "Equipamiento / Servicios" },
                    { id: 7,  res: 1, name: "Limpieza." },                    
                ],
                [   { id: 8,  res: 2, name: "Cómo valoraría la relación calidad/precio" },
                    { id: 9,  res: 2, name: "Volvería a utilizar el Plan de Vacaciones de los Fondos Sociales" },
                    { id: 10, res: 2, name: "Recomendaría nuestros servicios" },                                    
                    { id: 11, res: 3, name: "Cuál es el grado de satisfacción general con nuestro servicio" },                 
                ],
            ],

            options: [
                [],
                [   { value:4, text: 'Muy Bueno'},
                    { value:3, text: 'Bueno'},
                    { value:2, text: 'Regular'},
                    { value:1, text: 'Malo'},
                    //{ text: 'Regular', value: 'third', disabled: true },
                    //{ text: 'Malo', value: { fourth: 4 } }
                ],
                [   { value:4, text: 'Seguro que Si'},
                    { value:3, text: 'Posiblemente Si'},
                    { value:2, text: 'No estoy seguro'},
                    { value:1, text: 'Seguro que No'}
                ],
                [
                    { value:4, text: 'Completamente Satisfecho'},
                    { value:3, text: 'Satisfecho'},
                    { value:2, text: 'Insatisfecho'},
                    { value:1, text: 'Completamente Insatisfecho'}
                ],
            ]
        }
    },

    created() {
    },

    mounted() {  
        
        //let rr=this.$route.query.r.split('@')[1];
        let rr=this.$route.query.r;
        
        this.R={id: rr, per:'Periodo', hotel:'hotel', pob:'p', pro:'x'};
        //let yy=this.$util.decrypt(xx,'Nakaba0092.');    
        //let zz=this.$util.encrypt(rr,'Nakaba0092.');            

        this.reserva=rr;
        this.leemos();

    /////////////////////////////////////////////////////////////
      
    /* let r=this.$route.query.r.split('@');
      
    this.reserva=r[1];

    let aa=this.$util.codificaTexto(this.reserva,1);
    let bb=this.$util.codificaTexto(aa,2);
    let cc=this.$util.codificaTexto(bb,1);

    alert('*2*\n' + aa + '\n' + bb + '\n' + cc); */

    ///////////////////////////////////////////////////////////

    /* let x=this.$util.encriptar(this.reserva,1);
    let y=this.$util.encriptar(x,0);    
    let z=this.$util.encriptar(y,1);
    let a=this.$util.encriptar(z,0);
        
    alert('** encuesta.mounted: ' + this.reserva + '\n\ncodificado: ' + x + "\n\ndecodificado:" + y + "\n\ncodificado:" + z);
    alert(a); */
  },

  computed: {
    ...mapState(['auth','SOL','G']),
    
    logueado() {
        return this.auth.logueado;
    },   
    usuario() {
        return this.$store.state.auth.user;
    },


  },

  methods: {   
    ...mapMutations(['loading','alerta','modal']),
    ...mapActions(['exec']),

    async leemos() {
        let id=this.reserva;
        console.log('*leemos', id);

        //this.loading();        
        let r=await this.exec({api:'encuesta', arg: { fnt:'get', id: id } });
        //this.loading(false);

        if (r.error) {
            //mensaje error modal ... mostrar r.datos
            let m=(r.datos==''?'ERROR':r.datos);
            this.modal({tit: this.modulo, msg: m});          
            
            this.$router.push('/');                
            return;
        }
        //datos
        this.R=r.datos[0];
        //this.$store.state.EMP=r.datos[0]; //Object.values(r.datos[0]);
        this.faq=Object.values(r.datos[1]);    
        
        this.show=true;
    },

    async enviar() {
        //alert('Enviamos Encuesta');
        let msg="Estas Seguro envio ENCUESTA RESERVA <b>" + this.R.id + "</b>?<br>";
        let r=await this.$root.$msgConf(msg, this.modulo);
        if (!r) return;
        
        let rr=this.resp.slice(1); // eliminamos el primero .. shift();

        r=await this.exec({api:'encuesta', 
            arg: { fnt:'set', id: this.R.id, res: rr, txt: this.obs } });        

        if (r.error) {
            //mensaje error modal ... mostrar r.datos
            let m=(r.datos==''?'ERROR':r.datos);
            this.modal({tit: this.modulo, msg: m});          
            
            //this.$router.push('/');                
            return;
        }

        this.modal({tit: this.modulo, msg: r.datos });          
        this.show=false;
        this.$router.push('/');                

    },    
    
   }

}
</script>
